import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

const AUTO_REFRESH_INTERVAL = 5_000; // 5 seconds
const STORAGE_KEY = "fleet-auto-refresh";

export function getAutoRefreshDefault(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === null ? true : stored === "true";
}

export function setAutoRefreshPersisted(enabled: boolean) {
  localStorage.setItem(STORAGE_KEY, String(enabled));
}

export function useAutoRefresh(enabled: boolean) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => {
      void queryClient.invalidateQueries({ queryKey: ["machines"] });
      void queryClient.invalidateQueries({ queryKey: ["cbg-machines"] });
      void queryClient.invalidateQueries({ queryKey: ["spot-targets"] });
      void queryClient.invalidateQueries({ queryKey: ["capacity-block-groups"] });
      void queryClient.invalidateQueries({ queryKey: ["ci-runs"] });
    }, AUTO_REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [enabled, queryClient]);
}
